/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';
  const logoSrc = isLight
    ? '/logo/AIRSTUDIO_Logo_Blue.png'
    : '/logo/AIRSTUDIO_Logo_White.png';

  const logo = (
    <Box
      sx={{
        width: 180,
        height: 48,
        display: 'flex',
        alignItems: 'center',
        ...sx,
      }}
    >
      <Box
        component="img"
        src={logoSrc}
        alt="AIRStudio"
        sx={{
          height: '100%',
          width: 'auto',
          maxWidth: '100%',
          objectFit: 'contain',
          objectPosition: 'left center',
        }}
      />
    </Box>
  );

  if (disabledLink) {
    return logo;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
